import React from 'react';
import { useParams, Link } from 'react-router-dom';
import useNewsArticle from '../../hooks/useNewsArticle';
import './NewsDetail.css';

function linkifyText(text) {
  if (!text) return null;
  return text.split(/(https?:\/\/[^\s]+)/g).map((part, i) => {
    if (/^https?:\/\//.test(part)) {
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="article-inline-link-news"
        >
          {part}
        </a>
      );
    }
    return part;
  });
}

function NewsDetail() {
  const { id } = useParams(); // This is actually the slug
  const { article, loading, error } = useNewsArticle(id);
  
  if (loading) {
    return (
      <div className="news-detail-page-news">
        <div className="news-detail-header-news">
          <div className="header-content-news">
            <Link to="/news" className="back-button-news">← Back to News</Link>
          </div>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading article...</p>
        </div>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="news-detail-page-news">
        <div className="news-detail-header-news">
          <div className="header-content-news">
            <Link to="/news" className="back-button-news">← Back to News</Link>
          </div>
        </div>
        <div className="news-detail-error-news">
          <h1>Article not found</h1>
          <p>The article you're looking for doesn't exist or has been removed.</p>
          <Link to="/news" className="back-link-news">← Back to News</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="news-detail-page-news">
      {/* Header */}
      <div className="news-detail-header-news">
        <div className="header-content-news">
          <Link to="/news" className="back-button-news">← Back to News</Link>
        </div>
      </div>

      {/* Article Content */}
      <div className="news-detail-container-news">
        <div className="article-layout-news">
          <div className="article-image-section-news">
            <img src={article.image} alt={article.title} />
          </div>
          <div className="article-content-section-news">
            <p className="article-date-news">{article.date}</p>
            <h2 className="article-title-news">{article.title}</h2>
            <p className="article-description-news">{linkifyText(article.content)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsDetail; 